
import {
    SedestralStorage
} from "../../sedestral/framework/memory/SedestralStorage";

export class PreferencesService {
    private static _editorSpellChecker: boolean;

    static get editorSpellChecker(): boolean {
        return this._editorSpellChecker;
    }

    static set editorSpellChecker(value: boolean) {
        SedestralStorage.setItem("_editorSpellChecker", JSON.stringify(value));
        this._editorSpellChecker = value;
    }

    private static _editorLineMode: string;

    static get editorLineMode(): string {
        return this._editorLineMode;
    }

    static set editorLineMode(value: string) {
        SedestralStorage.setItem("_editorLineMode", value);
        this._editorLineMode = value;
    }

    private static _mediaVolume: number;

    static get mediaVolume(): number {
        return this._mediaVolume;
    }

    static set mediaVolume(value: number) {
        SedestralStorage.setItem("_mediaVolume", "" + value);
        this._mediaVolume = value;
    }


    private static _hour12: boolean;

    static get hour12(): boolean {
        return this._hour12;
    }

    static set hour12(value: boolean) {
        SedestralStorage.setItem("_hour12", JSON.stringify(value));
        this._hour12 = value;
    }

    public static init(): void {
        const storedSpellChecker = SedestralStorage.getItem("_editorSpellChecker");
        this._editorSpellChecker = storedSpellChecker != undefined ? JSON.parse(storedSpellChecker) : false;
        this._editorLineMode = SedestralStorage.getItem("_editorLineMode");
        this._mediaVolume = SedestralStorage.getItem("_mediaVolume") == undefined ? 0.5 : parseFloat(SedestralStorage.getItem("_mediaVolume"));
        this._hour12 = new Intl.DateTimeFormat().resolvedOptions().hour12;
    }

    public static dispose(): void {

    }
}